module.exports = __webpack_public_path__ + "img/menu-accounting-points.5084fd79.svg";